module.exports = __webpack_public_path__ + "img/Group437@2x.1b3d7550.png";